<template>
	<p><slot /></p>
  </template>
  
  <style scoped>
  p {
	font-family: var(--typography-font-body);
	font-size: var(--prose-p-font-size);
	line-height: var(--prose-p-line-height);
	margin: 10px;
  }
  
  :deep(br) {
	display: block;
	content: '';
	margin: 1px;
  }
  </style>